<template>
    <div>
        <div>* 将鼠标悬浮在每一行的左方控件上, 会出现输入类型的选项, 点击上下箭头切换为「常量」「字段」「枚举」「式」</div>
        <div>* 一个「式」可以作为参数被处于它下方的其他「式」引用</div>
        <div>* 请暂且使用Chrome浏览器</div>
        <div v-for="(i, index) in allInsts">
            <expression-atom :name="`式${index+1}`" :variables="fields" :instances="providedInsts[index]" @alter="alterInst($event, index)"></expression-atom>
            <expression-note :instance="i" mode="code" prefix="MYSQL: "></expression-note>
            <expression-note :instance="i" mode="display" prefix="说明: "></expression-note>
        </div>
        <div style="cursor: pointer; font-size: 1.5em; margin-top: 40px; margin-bottom: 40px" @click="addInst">+ 增加一行新「式」</div>
        <div style="height: 4px; border-bottom: 1px solid #ddd"></div>
        <div style="height: 4px; margin-top: 30px"></div>
        <div>* 操作符可动态添加, 点击添加后再次查看数字类型所联想的操作符</div>
        <div style="text-align: left; margin-top: 20px">
            <div style="text-indent: 40%">new Template({</div>
            <div style="text-indent: 44%">name: '立方',</div>
            <div style="text-indent: 44%">context: 'mysql-cn',</div>
            <div style="text-indent: 44%">templateDisplay: '立方($1)',</div>
            <div style="text-indent: 44%">templateCode: '$1*$1*$1',</div>
            <div style="text-indent: 44%">resultDataType: 'number',</div>
            <div style="text-indent: 44%">params: {</div>
            <div style="text-indent: 48%">$1: new Parameter({</div>
            <div style="text-indent: 52%">dataType: 'number'</div>
            <div style="text-indent: 48%">})</div>
            <div style="text-indent: 44%">}</div>
            <div style="text-indent: 40%">}).as('立方');</div>
        </div>
        <div style="cursor: pointer; font-size: 1.5em; margin-top: 40px; margin-bottom: 40px" @click="addOper">+ 增加操作符「立方」</div>
    </div>
</template>

<script>

    import ExpressionAtom from '../../mould-v/clause/ExpressionAtom'
    import ExpressionNote from '../../mould-v/explain/ExpressionNote'
    import { OP, Template, Parameter, Table, Field, Enum, Operators, i18n } from '../../mould';

    export default {

        name: 'demo-cn',

        components: {ExpressionAtom, ExpressionNote},

        data(){
            return {
                fields: [],
                allInsts: [null, null],
                providedInsts: [],
                added: false
            }
        },

        computed: {

        },

        mounted(){

            i18n.switchTo('cn');
            Operators.activateContext('mysql-cn');

            let allData = [
                new Table({
                    name: 'USER_INFO_DIM',
                    label: '用户信息维表'
                }).addFields([
                    new Field({
                        name: 'USER_ID',
                        label: '用户ID',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'USER_NAME',
                        label: '用户名称',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'AGE',
                        label: '年龄',
                        dataType: 'number',
                        distributeType: 'metrics',
                        unit: '岁'
                    }),
                    new Field({
                        name: 'GENDER',
                        label: '性别',
                        dataType: 'number',
                        distributeType: 'category',
                    }).addEnums([
                        new Enum({
                            code: 0,
                            label: '男'
                        }),
                        new Enum({
                            code: 1,
                            label: '女'
                        })
                    ])
                ]),

                new Table({
                    name: 'COMMODITY_INFO_DIM',
                    label: '商品信息维表'
                }).addFields([
                    new Field({
                        name: 'COMMODITY_ID',
                        label: '商品ID',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'COMMODITY_NAME',
                        label: '商品名称',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'UNIT_PRICE',
                        label: '单价',
                        dataType: 'number',
                        distributeType: 'metrics',
                        unit: '元'
                    }),
                ]),

                new Table({
                    name: 'COMMODITY_PURCHASE_LOG',
                    label: '商品购买记录表'
                }).addFields([
                    new Field({
                        name: 'COMMODITY_ID',
                        label: '商品ID(禁用)',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'USER_ID',
                        label: '用户ID(禁用)',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'QUANTITY',
                        label: '交易数量',
                        dataType: 'number',
                        distributeType: 'metrics',
                        unit: '个'
                    }),
                    new Field({
                        name: 'DISCOUNT',
                        label: '折扣',
                        dataType: 'string',
                        distributeType: 'category',
                    }).addEnums([
                        new Enum({
                            code: 'none',
                            label: '无折扣'
                        }),
                        new Enum({
                            code: '0.8-all',
                            label: '总价8折'
                        }),
                        new Enum({
                            code: '0.5-sec',
                            label: '第2个半价'
                        }),
                        new Enum({
                            code: 'free',
                            label: '白给'
                        })
                    ])
                ])
            ];

            this.fields = [];
            allData.forEach(t => {
                this.fields.push(...t.getFields());
            })

        },

        methods: {

            alterInst(inst, index){
                this.allInsts[index] = inst;
                this.updateProvided();
            },

            addInst(){
                this.allInsts.push(null);
                this.updateProvided();
            },

            addOper(){
                if(!this.added) {
                    new Template({
                        name: '立方',
                        context: 'mysql-cn',
                        templateDisplay: '立方($1)',
                        templateCode: '$1*$1*$1',
                        resultDataType: 'number',
                        params: {
                            $1: new Parameter({
                                dataType: 'number'
                            })
                        }
                    }).as('立方');
                    this.added = true;
                }
            },

            updateProvided(){
                this.$nextTick(() => {
                    let arr = [];
                    let len = this.allInsts.length;
                    this.allInsts.forEach((i, index) => {
                        arr.push(this.allInsts.slice(0, index));
                    });
                    this.providedInsts = arr;
                });
            }
        },

        watch: {


        }
    }
</script>

<style scoped>

</style>